import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { CommunicationLogic } from '../logic/CommunicationLogic.ts';

export const getCommunicationForwardText = (
  communication?: ComunicazioneDTO | null,
) => {
  if (!communication) return '';

  const date = communication.dataInvio
    ? `Data: ${new Date(communication.dataInvio).toLocaleString()}\n`
    : '';
  const recipients = CommunicationLogic.allRecipients(communication);
  const to =
    recipients.length > 0
      ? `Destinatari: ${recipients
          ?.map(destinatario => destinatario.denominazione)
          .join(', ')}\n`
      : '';
  const sender = CommunicationLogic.sender(communication);
  const from = sender ? `Mittente: ${sender.denominazione}\n` : '';

  const subject = communication.oggetto
    ? `Oggetto: ${communication.oggetto}\n`
    : '';
  const message = communication.messaggio
    ? `Messaggio: ${communication.messaggio}\n`
    : '';

  return `${date}${from}${to}${subject}${message}`;
};
